export default __webpack_public_path__ + "static/media/screen3.c01b6298.png";